import { IQuantity, Quantity } from "../../../common/models/quantity.model";
import { OrderTypeString, translateOrderTypeName } from "../../../common/enums/orderTypes.enum";

interface IActions {
    edit: () => void;
    verifyPickuPoint: (e:any) => Promise<void>;
}

export const generateItems = (
    quantity: IQuantity,
    actions: IActions,
    selectedUnactiveUser: any,
    activatedUsers: any,
    orderTypes: any,
    t: (key: string) => string
) => {

    const itemsArr = orderTypes.map(({ key, text }: any) => {
        let icon = { iconProps: {} };
    
        if (text === OrderTypeString.Vehicle) {
          icon = { iconProps: { iconName: "Car" } };
        } else if (text === OrderTypeString.Container) {
          icon = { iconProps: { iconName: "Inbox" } };
        } else if (text === OrderTypeString.Weight) {
          icon = { iconProps: { iconName: "Weights" } };
        }
         
        return {
          key: key,
          id: key,
          text: translateOrderTypeName(text, t),
          iconProps: icon.iconProps,
          onClick: actions.verifyPickuPoint,
        };
      })
    switch (quantity) {
        case Quantity.NONE:
            return [

            ];
        case Quantity.ONE:
            if (selectedUnactiveUser && activatedUsers[selectedUnactiveUser.id]) {
                return [

                ];
            } else {

                return [
                    {
                        key: "verify",
                        text: t("clients.commands.verify"),
                        iconProps: { iconName: "send" },
                        name: "verify",
                        subMenuProps: {
                            items: [...itemsArr],
                        },
                    },
                    {
                        key: "edit",
                        text: t("clients.commands.edit"),
                        iconProps: { iconName: "edit" },
                        name: "edit",
                        onClick: actions.edit
                    }
                ];
            }

        default:
            return [];
    }
};
